import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AlertController } from '@ionic/angular';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { tap, map, switchMap, take } from 'rxjs/operators';
import { SWASTHCONFIG } from '../../config';
import { SwasthStorageService } from '../storage/swasth-storage.service';
import { Storage } from '@ionic/storage';
import { ModulesApisService } from '../services/modules-apis.service';
import { WebsocketService } from "../services/websocket.service";

const helper = new JwtHelperService();
const TOKEN_KEY = 'swplus-token';
const REMEMBERME = 'rememberme';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  isRemember: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  token = '';
  remeStatus = "";
  S3BASE_URL=SWASTHCONFIG.S3BASE_URL;

  constructor(private readonly httpClient: HttpClient, private swstorage: SwasthStorageService, 
    private alertCtrl: AlertController, private router: Router, private storage: Storage, private modulesApis: ModulesApisService,
    private webSocket : WebsocketService) { 
      this.loadToken();
    }

  async loadToken() {
    if(this.storage.get(TOKEN_KEY))
    {
    console.log(': ', this.swstorage.getStorage(TOKEN_KEY));
    const token = await this.swstorage.getStorage(TOKEN_KEY);
    console.log('reme : ', this.swstorage.getStorage(REMEMBERME));
    const rememberSt = await this.swstorage.getStorage(REMEMBERME);
    if (token) {
      console.log('set token: ', token);
      this.token = token;      
      let decodedToken = helper.decodeToken(this.token);
      this.modulesApis.decodedToken = decodedToken;
      this.webSocket.subcribe(decodedToken.UID,true);
      this.isAuthenticated.next(true);
    } else {
      this.isAuthenticated.next(false);
    }
    if (rememberSt) {
      console.log('remell set token: ', rememberSt);
      this.remeStatus = rememberSt;
      this.isRemember.next(true);
    } else {
      this.isRemember.next(false);
    }
    }
  }

  login(values, rememberMe): Observable<any> {
    return this.httpClient.post(`${SWASTHCONFIG.SERVER_URL}/circlelogin`, values, {responseType: 'text'}).pipe(
      take(1),
      switchMap(token => {
        if(token !== 'NOTEXISTS'){     
          this.token = token;
          // console.log('switch token: ', token);  
          if(rememberMe == 1) {
            from(this.storage.set(REMEMBERME, 'yes'));
          }        
          let decodedToken = helper.decodeToken(this.token);
          this.webSocket.subcribe(decodedToken.UID,true);
          this.modulesApis.decodedToken = helper.decodeToken(this.token);
          return from(this.storage.set(TOKEN_KEY, token));
        } else if(token == 'NOTEXISTS') {
          this.showToast();
        }else {
          alert("user not exists");
        }        
      }),
      tap(_ => {
        this.isAuthenticated.next(true);
        this.isRemember.next(true);
      })
    );
  }

  otpLogin(values): Observable<any> {
    return this.httpClient.post(`${SWASTHCONFIG.SERVER_URL}/loginotp`, values, {responseType: 'text'}).pipe(
      take(1),
      switchMap(token => {
        if(token !== 'NOTEXISTS'){     
          this.token = token;
          // console.log('switch token: ', token);  
          // if(rememberMe == 1) {
          //   from(this.storage.set(REMEMBERME, 'yes'));
          // }        
          let decodedToken = helper.decodeToken(this.token);
          this.webSocket.subcribe(decodedToken.UID,true);
          this.modulesApis.decodedToken = helper.decodeToken(this.token);
          return from(this.storage.set(TOKEN_KEY, token));
        } else if(token == 'NOTEXISTS') {
          this.showToast();
        }else {
          alert("user not exists");
        }        
      }),
      tap(_ => {
        this.isAuthenticated.next(true);
        this.isRemember.next(true);
      })
    );
  }

  getServerTime() {
    let url = SWASTHCONFIG.LOOKUP_URL+"/getServerDateTime/";
    return this.httpClient.get(url, {responseType: "text"});
  }

  getAppointmentList(apptObj) {
    var epurl=SWASTHCONFIG.SWASTHPLUS+"/getdocappointmentlist";
    return this.httpClient.post(epurl, apptObj, {responseType: "json"});
  }

  createSwasthVideoChatRoom(videoObj) {
    var epurl=SWASTHCONFIG.SWASTHPLUS+"/createswasthvideochatroom";
    return this.httpClient.post(epurl, videoObj, {responseType: "text"});
  }

  updateSwasthVideoAppt(apptObj) {
    var epurl=SWASTHCONFIG.SWASTHPLUS+"/updateswasthvideoappt";
    return this.httpClient.post(epurl, apptObj, {responseType: "text"});
  }

  private async showToast() {
    // console.log("Response Message======"+data);      
    const alert = await this.alertCtrl.create({
      header: 'Login Failed',
      message: 'Invalid User ID',
      buttons: ['ok']
    });
    await alert.present();
  }

  getPatientAppointment(apptObj) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/getpatientappointments";
    return this.httpClient.put(epurl, apptObj, { responseType: "json" });    
  }

  getPatientAppointmentforchatroom(ptuid:any,docuid:any,tenantid:any) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/getpatientappointmentsbyuid/"+docuid+"/"+ptuid+"/"+tenantid;
    return this.httpClient.put(epurl, { responseType: "json" });    
  }
 
  logout() {
    this.isAuthenticated.next(false);
    this.isRemember.next(false);
    this.router.navigateByUrl('/login');
    this.swstorage.removeStorage(TOKEN_KEY);
    this.swstorage.removeStorage(REMEMBERME);    
  }

}

